// extracted by mini-css-extract-plugin
export default {"spinner-wrapper":"spinner_spinner-wrapper__jNKQw"};